import { motion } from 'framer-motion';
import styled from 'styled-components';

export const Frame = styled(motion.div)<{
  $left: number;
  $top: number;
  $width: number;
  $height: number;
}>`
  position: absolute;
  top: ${({ $top }) => `${$top}px`};
  left: ${({ $left }) => `${$left}px`};
  width: ${({ $width }) => `${$width}px`};
  height: ${({ $height }) => `${$height}px`};

  img,
  svg {
    position: absolute;
    inset: 0;
    width: 100%;
    height: 100%;
  }
`;
